import { NavLink, generatePath, useNavigate } from 'react-router-dom';
import { IconRight, ButtonPrimary, ButtonSize } from '@ui/src';
import Card from '../partial/card/card';
import CardItem from './card-item';
import { CardGeneralTypes } from './types';

import { CardsRoutes } from '../../routes';

import cn from './card.module.css';

const CardGeneral = ({
  user,
  cards,
  isLoading,
  changeStatusInProgress,
  cardId,
  id,
  search,
  changeStatusSuccess,
}: CardGeneralTypes) => {
  const navigate = useNavigate();

  const setOrderCardPanelVisible = () => {
    navigate(
      generatePath(`${CardsRoutes.CARD_ORDER}${search || ''}`, {
        cardId: cardId as string,
        id: id as string,
      }),
    );
  };

  return (
    <Card
      transparent
      isLoading={isLoading}
      title={
        <div className={cn.cardGeneralTitleWrapper}>
          <div
            className={cn.cardGeneralTitle}
          >{`${user?.firstName} ${user?.lastName}`}</div>
          <NavLink
            to={`/customers/individual/${user?.id}`}
            className={cn.cardGeneralUserLink}
          >
            Open profile
            <IconRight />
          </NavLink>
        </div>
      }
      className={cn.cardsList}
    >
      <div>
        <ButtonPrimary
          text="Order a card"
          size={ButtonSize.SMALL}
          className={cn.orderCardButton}
          onClick={setOrderCardPanelVisible}
          bold
        />
        {cards?.map((card, index) => (
          <CardItem
            key={card.id}
            card={card}
            changeStatusInProgress={changeStatusInProgress}
            zIndex={cards.length - index}
            cardId={cardId}
            id={id}
            search={search}
            setOrderCardPanelVisible={setOrderCardPanelVisible}
            changeStatusSuccess={changeStatusSuccess}
          />
        ))}
      </div>
    </Card>
  );
};

export default CardGeneral;
